import { render, staticRenderFns } from "./quizzesIndex.vue?vue&type=template&id=43924f3a&"
import script from "./quizzesIndex.vue?vue&type=script&lang=js&"
export * from "./quizzesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports